import React, { Component } from 'react';
import { observer , inject } from 'mobx-react';


class Timeout extends Component {
    constructor(props){
        super(props);
    }

    //onMountShowTimeout

    render() {
        return(
            <div className="modalMessage">
              <div className="title">Your session will expire soon and you will be logged out.</div>
              <button className="bigButton">
                  I&rsquo;m Still Here
              </button>
            </div>
        );
    }
}

export default Timeout;




// WEBPACK FOOTER //
// ./src/components/DGR/Modal/Timeout.js